import { render, staticRenderFns } from "./IconsInterfaceEmployee.vue?vue&type=template&id=006a885e&scoped=true&"
import script from "./IconsInterfaceEmployee.vue?vue&type=script&lang=js&"
export * from "./IconsInterfaceEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a885e",
  null
  
)

export default component.exports